import { render, staticRenderFns } from "./MaterialSesion.vue?vue&type=template&id=245386f3&"
import script from "./MaterialSesion.vue?vue&type=script&lang=js&"
export * from "./MaterialSesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports